export const MATERIAL_TYPES_FEATURE_KEY = 'material-types';
